import { useGet } from "@/apiHooks/HttpFunctions";
import { FILTER_TYPE } from "@/constant/constants";
import {
  editionsMasterDataApi,
  productsMasterDataApi,
  sportsMasterDataApi,
  teamsMasterDataApi,
  termsMasterDataApi,
} from "@/apis/apis";
import { LIST_MODE } from "@/constant/Lists/listMode";
import { statusBaseProductFilters } from "@/constant/BaseProduct/status";

export const useFilters = (productGroup) => {
  const { data: sportsData, error: sportsError } = useGet({
    apiURL: `${sportsMasterDataApi}?mode=${LIST_MODE.ALL}`,
  });

  const { data: productsData, error: productsError } = useGet({
    apiURL: `${productsMasterDataApi}?mode=${LIST_MODE.ALL}&filter[product_group]=${productGroup}`,
  });

  const { data: teamsData, error: teamsError } = useGet({
    apiURL: `${teamsMasterDataApi}?mode=${LIST_MODE.ALL}`,
  });

  const { data: termsData, error: termsError } = useGet({
    apiURL: `${termsMasterDataApi}?mode=${LIST_MODE.ALL}`,
  });

  const { data: editionsData, error: editionsError } = useGet({
    apiURL: `${editionsMasterDataApi}?mode=${LIST_MODE.ALL}`,
  });

  const sportOptions = [
    { label: "All Sport", value: "" },
    ...(sportsData?.data?.map((sport) => ({
      label: sport.code,
      value: "" + sport.id,
    })) || []),
  ];

  const productOptions = [
    { label: "All Product", value: "" },
    ...(productsData?.data?.map((product) => ({
      label: product.code,
      value: "" + product.id,
    })) || []),
  ];

  const teamOptions = [
    { label: "All Team", value: "" },
    ...(teamsData?.data?.map((team) => ({
      label: team.code + " - " + team.name,
      value: "" + team.id,
    })) || []),
  ];

  const termOptions = [
    { label: "All Term", value: "" },
    ...(termsData?.data?.map((term) => ({
      label: term.code,
      value: "" + term.id,
    })) || []),
  ];

  const editionOptions = [
    { label: "All Edition", value: "" },
    ...(editionsData?.data?.map((edition) => ({
      label: edition.code,
      value: "" + edition.id,
    })) || []),
  ];

  const statusFiltersMap = statusBaseProductFilters();

  // Define the filters
  return [
    {
      id: "filter[status]",
      label: "Status",
      type: FILTER_TYPE.SELECT,
      options: Object.entries(statusFiltersMap).map(([value, label]) => ({
        label,
        value,
      })),
    },
    {
      id: "filter[sport]",
      label: "Sport ID",
      type: FILTER_TYPE.SELECT,
      options: sportOptions,
    },
    {
      id: "filter[product]",
      label: "Product ID",
      type: FILTER_TYPE.SELECT,
      options: productOptions,
    },
    {
      id: "filter[team]",
      label: "Team ID",
      type: FILTER_TYPE.SELECT,
      options: teamOptions,
    },
    {
      id: "filter[term]",
      label: "Term ID",
      type: FILTER_TYPE.SELECT,
      options: termOptions,
    },
    {
      id: "filter[edition]",
      label: "Edition ID",
      type: FILTER_TYPE.SELECT,
      options: editionOptions,
    },
  ];
};
